import { getApi } from "../client/apiClient";
import type { HttpClient } from "../client/types";
import type {
  PoolRegulation,
  ReportType,
  MaintenanceType,
  AdverseEventType,
  InterventionLevel,
  EventMainFactor,
  EventSpecificFactor,
  AdverseEventInterventionLevel,
} from "../client/types/catalog.types";
import type { Status } from "../client/types/common.types";

const createCatalogEndpoints = (client: HttpClient = getApi()) => ({
  getStatuses: async (): Promise<Status[]> => {
    const { data } = await client.get<Status[]>("/catalog/statuses");
    return data;
  },
  getReportTypes: async (): Promise<ReportType[]> => {
    const { data } = await client.get<ReportType[]>("/catalog/report-types");
    return data;
  },
  getPoolRegulations: async (): Promise<PoolRegulation[]> => {
    const { data } = await client.get<PoolRegulation[]>(
      "/catalog/pool-regulations"
    );
    return data;
  },
  getMaintenanceTypes: async (): Promise<MaintenanceType[]> => {
    const { data } = await client.get<MaintenanceType[]>(
      "/catalog/maintenance-types"
    );
    return data;
  },
  getAdverseEventTypes: async (): Promise<AdverseEventType[]> => {
    const { data } = await client.get<AdverseEventType[]>(
      "/catalog/adverse-event-types"
    );
    return data;
  },
  getInterventionLevels: async (): Promise<InterventionLevel[]> => {
    const { data } = await client.get<InterventionLevel[]>(
      "/catalog/intervention-levels"
    );
    return data;
  },
  getEventMainFactors: async (): Promise<EventMainFactor[]> => {
    const { data } = await client.get<EventMainFactor[]>(
      "/catalog/event-main-factors"
    );
    return data;
  },
  getEventSpecificFactors: async (
    mainFactorId: number
  ): Promise<EventSpecificFactor[]> => {
    const { data } = await client.get<EventSpecificFactor[]>(
      `/catalog/event-specific-factors?main_factor_id=${mainFactorId}`
    );
    return data;
  },
  getAdverseEventInterventionLevels: async (
    adverseEventsTypeId: number
  ): Promise<AdverseEventInterventionLevel[]> => {
    const { data } = await client.get<AdverseEventInterventionLevel[]>(
      `/catalog/adverse-event-intervention-levels?adverse_events_type_id=${adverseEventsTypeId}`
    );
    return data;
  },
});

export type CatalogEndpoints = ReturnType<typeof createCatalogEndpoints>;

export const catalogEndpoints = createCatalogEndpoints();
